import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["ids", "radios"];

  connect() {}

  update_ids() {
    const checked = [...this.radiosTarget
      .querySelectorAll('input[type="radio"]:checked')]
      .filter(radio => radio.value === "Oui")
      .map(radio => radio.id.replace("pratical_information_radio_", "").replace("_Oui", ""));

      this.idsTarget.innerHTML = "";

      checked.forEach(id => {
        const hiddenId = document.createElement("input");
        hiddenId.setAttribute("type", "hidden");
        hiddenId.setAttribute("name", "service[practical_information_ids][]");
        hiddenId.setAttribute("value", id);
        this.idsTarget.appendChild(hiddenId);
      });
  }

  update_additional_info(e) {
    const id = e.target.dataset.id;
    const hiddenField = this.element.querySelector(`#service_practical_information_additional_info_${id}`);
    hiddenField.value = JSON.stringify({id: id, additional_info: e.target.value});
  }
}
